// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_DeductionsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { Payroll_UserDeductionRow } from './Payroll_UserDeductionRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_DeductionsResponseDados = Payroll_UserDeductionRow[];

export type Payroll_DeductionsResponse = ApiResponse<Payroll_DeductionsResponseDados>;

registerResponseContract('Payroll_DeductionsResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      id:                  { type: 'number',  required: true },
      payroll_period_id:   { type: 'number',  required: true },
      user_id:             { type: 'string',  required: true },
      franchise_id:        { type: 'number',  required: true },
      amount:              { type: 'string',  required: true },
      description:         { type: 'string',  required: true },
      despesa_id:          { type: 'number',  required: false },
      created_at:          { type: 'string',  required: true },
      created_by:          { type: 'string',  required: true },
      despesa_description: { type: 'string',  required: false },
      despesa_amount:      { type: 'string',  required: false },
    },
  },
})
